import { Steps, WizzardHeader } from '@/components'
import { AppLoading } from '@/components/AppLoading'
import { Step3 } from '@/containers/steps/poleas/step3/Step3'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'

import { QuotesProvider } from '@/context/QuotesContext'
import { SelectedQuoteProvider } from '@/context/SelectedQuoteContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { useGetAdditionalData } from '@/hooks/useWizard'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import type { WizardVehicleAdditionalData } from 'BrokerTsLib/src/dtos'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'


export function Step3Page() {
  return (
    <StepsProvider currentStepId={3}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          <QuotesProvider>
            <Step3Content />
          </QuotesProvider>
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

const Step3Content = () => {
  const navigate = useNavigate()
  const { insuranceParams, insuranceParamsId, isFetchingData } = useInsuranceParams()

  const { isLoading: isLoadingFormData, data: formData, refetch: refetchFormData } = useGetAdditionalData(insuranceParamsId!, {
    enabled: false,
    cacheTime: 0,
  })

  const data = formData?.data as WizardVehicleAdditionalData

  useEffect(() => {
    if (!insuranceParams) return

    if (!insuranceParams.generalParams.selectedOfferId && !isFetchingData) {
      navigate('/poleas/wizard/2')
      return
    }

    refetchFormData()
  }, [insuranceParams, isFetchingData])

  return (
    <>
      {(!insuranceParams) && <AppLoading />}
      {insuranceParams &&
        <SelectedQuoteProvider>
          <PageWrapper
            steps={<Steps />}
            header={<WizzardHeader />}
            sidebar={<Sidebar />}
            contentProps={{
              sx: {
                pt: { base: 0, md: 0 },
              },
            }}
          >
            {(isLoadingFormData || !data) && <AppLoading />}
            {!isLoadingFormData && data &&
              <Step3 data={data} />
            }
          </PageWrapper>
        </SelectedQuoteProvider>
      }
    </>
  )
}
